import { GET_USER_WALLET_ERROR, GET_USER_WALLET_REQUEST, GET_USER_WALLET, UPDATE_USER_WALLET_DATA, REMOVE_USER_WALLET } from "../ActionTypes/ActionTypes.js";

const initialState = {
    userWalletLoading: false,
    userWalletData: null,
    userWalletError: null,
    userWalletStatus: null,
    isModified: false,
    isFirstLoad: true,


};

const userWalletReducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_USER_WALLET_REQUEST:
            return { ...state, userWalletLoading: state.isFirstLoad, userWalletStatus: null, userWalletData: null };
        case GET_USER_WALLET:
            return {
                userWalletLoading: false, userWalletData: action.payload, userWalletError: null, userWalletStatus: true,

                isFirstLoad: false,
            };

        case GET_USER_WALLET_ERROR:
            return { userWalletLoading: false, userWalletData: null, userWalletError: action?.payload, userWalletStatus: false, isFirstLoad: false, };
        case UPDATE_USER_WALLET_DATA:
            return {
                ...state,
                userWalletData: {
                    ...state.userWalletData,
                    result: {
                        ...state.userWalletData.result,
                        ...action.payload,
                    },
                },
            };
        default:
            return state;
    }
};

export default userWalletReducer;